"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _reactRedux = require("react-redux");

var _commonData = require("../../../../../Shared/store/commonData/commonData.selector");

var _ProductItem = require("../../../../../Marketplace/Products/components/ProductItem");

var _CampaignIcon = _interopRequireDefault(require("../../../../../Shared/Campaigns/components/CampaignIcon/CampaignIcon"));

var _FavouriteButton = _interopRequireDefault(require("../../../../../Shared/Campaigns/components/FavouriteButton/FavouriteButton"));

var _useTrackGiftingFlow = require("../../../../hooks/useTrackGiftingFlow");

var _features = require("../../../../../Shared/store/features");

var _BudgetSettingsItem = _interopRequireDefault(require("./BudgetSettingsItem"));

var styles = {
  root: {
    display: 'block',
    backgroundColor: 'common.white',
    p: 0,
    boxShadow: '0px 2px 5px rgba(51, 68, 124, 0.15)',
    borderRadius: '5px',
    border: 'none',
    textAlign: 'left',
    width: '100%'
  },
  rootClickable: {
    cursor: 'pointer'
  },
  header: {
    p: 2
  },
  title: {
    lineHeight: '1.5rem',
    color: 'primary.main',
    fontWeight: 700
  },
  subtitle: {
    fontSize: '0.75rem',
    lineHeight: '1.125rem',
    color: 'primary.main',
    display: 'flex',
    alignItems: 'center'
  },
  invitesAmount: {
    fontSize: '0.75rem',
    lineHeight: '1.125rem',
    color: 'primary.main'
  },
  countries: {
    ["& .".concat(_material.avatarClasses.root)]: {
      width: 16,
      height: 16,
      border: 'none',
      ml: -0.5
    }
  },
  footer: {
    width: '100%',
    border: 'none',
    borderTop: "1px solid",
    borderColor: 'primary.superLight',
    color: 'link.main',
    py: 1,
    pl: 7.5,
    background: 'transparent',
    display: 'flex',
    alignItems: 'center',
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    fontWeight: 700,
    cursor: 'pointer'
  },
  footerIcon: {
    ml: 1
  },
  details: {
    pl: 7.5,
    pb: 2,
    pr: 2,
    color: 'grey.chambray50',
    fontSize: '0.75rem',
    lineHeight: '1rem'
  },
  textEllipsis: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  skeleton: {
    borderRadius: '5px'
  }
};
var SButton = (0, _material.styled)('button')({});

var CampaignGridItem = function CampaignGridItem(_ref) {
  var _campaign$giftsLimit, _campaign$giftsLimit2, _campaign$defaultProd;

  var campaign = _ref.campaign,
      measure = _ref.measure,
      expanded = _ref.expanded,
      onToggleExpand = _ref.onToggleExpand,
      onClick = _ref.onClick,
      onChangeIsFavourite = _ref.onChangeIsFavourite;
  (0, _react.useEffect)(function () {
    measure();
  }, [expanded, measure]);
  var multipleValues = (0, _reactRedux.useSelector)(_features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.MULTIPLE_GIFT_CARD_VALUES));
  var countries = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    var _campaign$countryIds;

    return (0, _commonData.makeGetCountriesByIds)((_campaign$countryIds = campaign === null || campaign === void 0 ? void 0 : campaign.countryIds) !== null && _campaign$countryIds !== void 0 ? _campaign$countryIds : []);
  }, [campaign]));
  var isGiftInvitesExists = !!campaign && ((_campaign$giftsLimit = campaign.giftsLimit) !== null && _campaign$giftsLimit !== void 0 ? _campaign$giftsLimit : 0) > 0;
  var trackCampaignsListDetailsToggled = (0, _useTrackGiftingFlow.useCampaignsListDetailsToggled)();
  var trackCampaignsListCampaignSelected = (0, _useTrackGiftingFlow.useCampaignsListCampaignSelected)();
  var handleDetailsClick = (0, _react.useCallback)(function (event) {
    event.stopPropagation();

    if (campaign !== null && campaign !== void 0 && campaign.id) {
      onToggleExpand(campaign.id);
      trackCampaignsListDetailsToggled({
        campaignId: campaign.id,
        isOpened: !expanded
      });
    }
  }, [campaign, onToggleExpand, expanded, trackCampaignsListDetailsToggled]);
  var handleCampaignClick = (0, _react.useCallback)(function () {
    if (campaign && isGiftInvitesExists) {
      onClick(campaign);
      trackCampaignsListCampaignSelected({
        campaignId: campaign.id,
        campaignType: campaign.type
      });
    }
  }, [campaign, isGiftInvitesExists, onClick, trackCampaignsListCampaignSelected]);

  if (!campaign) {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: styles.root
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: styles.header
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      display: "flex",
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
      variant: "circular",
      width: 36,
      height: 36
    }), /*#__PURE__*/_react.default.createElement(_material.Box, {
      ml: 1
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: styles.title
    }, /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
      variant: "text",
      width: 150
    })), /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: styles.subtitle
    }, /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
      variant: "text",
      width: 275
    }))))), /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: styles.footer
    }, /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
      width: 90
    })));
  }

  var isPhysicalBudgetExists = typeof campaign.budgetSettings.minPrice === 'number' && typeof campaign.budgetSettings.maxPrice === 'number' && !multipleValues;
  var isGiftCardBudgetExists = typeof campaign.budgetSettings.giftCardPrice === 'number' && !multipleValues;
  var isDonationBidgetExists = typeof campaign.budgetSettings.donationPrice === 'number' && !multipleValues;
  var giftActionsValue = multipleValues ? "Exchange value is ".concat(campaign.budgetSettings.recipientMarketplaceThreshold.label, " of the sent-gift cost") : "".concat(campaign.giftActions.exchange && 'Exchange').concat(campaign.giftActions.donate && ', Donate', " Allowed");
  return /*#__PURE__*/_react.default.createElement(SButton, {
    sx: [styles.root, isGiftInvitesExists && styles.rootClickable],
    onClick: handleCampaignClick,
    "data-testid": "SelectCampaign.CampaignsGrid.".concat(campaign.name)
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.header
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_CampaignIcon.default, {
    variant: campaign.type
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    ml: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.title
  }, campaign.name), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.subtitle
  }, campaign.owner.firstName, " ", campaign.owner.lastName, "\xA0|\xA0", campaign.team.name, "\xA0|\xA0", /*#__PURE__*/_react.default.createElement(_material.AvatarGroup, {
    sx: styles.countries,
    total: Math.min(5, countries.length)
  }, countries.map(function (_ref2) {
    var name = _ref2.name,
        image = _ref2.image;
    return /*#__PURE__*/_react.default.createElement(_material.Avatar, {
      key: name,
      alt: name,
      src: image
    });
  })), countries.length > 5 && /*#__PURE__*/_react.default.createElement(_material.Box, {
    color: "link.main",
    fontSize: "0.85rem"
  }, "\xA0+", countries.length - 5)))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(_FavouriteButton.default, {
    favourite: campaign.isFavourite,
    onClick: function onClick(event) {
      event.stopPropagation();
      onChangeIsFavourite(campaign.id, !campaign.isFavourite);
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.invitesAmount
  }, (_campaign$giftsLimit2 = campaign === null || campaign === void 0 ? void 0 : campaign.giftsLimit) !== null && _campaign$giftsLimit2 !== void 0 ? _campaign$giftsLimit2 : 0, " invites")))), expanded && /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.details
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    flexBasis: "60%"
  }, /*#__PURE__*/_react.default.createElement(_BudgetSettingsItem.default, {
    campaign: campaign,
    label: "Merchandise/Experiences",
    minPrice: campaign.budgetSettings.minPrice,
    maxPrice: campaign.budgetSettings.maxPrice
  }), /*#__PURE__*/_react.default.createElement(_BudgetSettingsItem.default, {
    campaign: campaign,
    label: "Gift cards",
    minPrice: campaign === null || campaign === void 0 ? void 0 : campaign.budgetSettings.giftCardMinPrice,
    maxPrice: campaign === null || campaign === void 0 ? void 0 : campaign.budgetSettings.giftCardMaxPrice
  }), /*#__PURE__*/_react.default.createElement(_BudgetSettingsItem.default, {
    campaign: campaign,
    label: "Donations",
    minPrice: campaign.budgetSettings.donationMinPrice,
    maxPrice: campaign.budgetSettings.donationMaxPrice
  }), isPhysicalBudgetExists && /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement("b", null, "Gift budget:"), " $", campaign.budgetSettings.minPrice, " - $", campaign.budgetSettings.maxPrice), isGiftCardBudgetExists && /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement("b", null, "Gift cards"), " $", campaign.budgetSettings.giftCardPrice), isDonationBidgetExists && /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement("b", null, "Donations"), " $", campaign.budgetSettings.donationPrice), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 1
  }, giftActionsValue), !!campaign.messageSubject && /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement("b", null, "Message:"), " ", campaign.messageSubject), !!campaign.sendAs && /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement("b", null, "Send As:"), " ", campaign.sendAs.firstName, " ", campaign.sendAs.lastName), !!campaign.campaignInstruction && /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement("b", null, "Campaign Instruction:"), " ", campaign.campaignInstruction)), !!(campaign !== null && campaign !== void 0 && (_campaign$defaultProd = campaign.defaultProducts) !== null && _campaign$defaultProd !== void 0 && _campaign$defaultProd.length) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    flexBasis: "40%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    fontWeight: 700
  }, "Default Gifts:"), campaign.defaultProducts.map(function (product) {
    return /*#__PURE__*/_react.default.createElement(_ProductItem.ConnectedTextProductItem, {
      key: product.id,
      sx: styles.textEllipsis,
      id: product.id,
      denomination: product.denomination,
      hidePrice: true
    });
  })))), /*#__PURE__*/_react.default.createElement(SButton, {
    sx: styles.footer,
    onClick: handleDetailsClick
  }, "Details", /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    sx: styles.footerIcon,
    icon: expanded ? 'chevron-up' : 'chevron-down'
  })));
};

var _default = CampaignGridItem;
exports.default = _default;